<template>
  <div class="recent-orders">
    <div class="recent-order-content">
      <div class="recent-orders-inside-wrapper">
        <div class="recent-orders-details">
          <span class="date">{{ formatDate(getDate(orders)) }}</span>
          <span class="time">
            {{ formatTime(getDate(orders)) }} &nbsp;
            <span class="recent-orders-qr">{{
              tableQRLabel(orders[0].tableQR)
            }}</span>
          </span>
        </div>
        <div class="product-type-section">
          <!-- Menu Group Start -->
          <div v-for="(order, index) in getMenuGroupOrders" :key="index">
            <ul class="recent-orders-items-list">
              <li class="recent-menugroup-orders-item">
                <button
                  v-if="!hasRoleWaiter"
                  type="button"
                  class="remove-product"
                  @click="openSelectOptionModel(order)"
                >
                  <font-awesome-icon
                    icon="minus-square"
                    :style="{ color: '#ea2222', fontSize: 20 }"
                  />
                </button>
                <h3
                  class="recent-orders-product-type"
                  style="grid-column: span 5/7"
                >
                  {{ order.name }}
                </h3>

                <span class="price">{{
                  formatPrice(order.price * order.quantity)
                }}</span>
              </li>
            </ul>

            <h3 class="recent-orders-product-type">COMIDA</h3>
            <ul class="recent-orders-items-list">
              <li class="order-metadata-title" v-if="order.starters.length > 0">
                PRIMERO
              </li>
              <li
                class="recent-orders-item"
                v-for="starter in order.starters"
                :key="`starter_${starter.id}`"
              >
                <span class="delivered">
                  <v-checkbox
                    class="mt-0"
                    v-model="starter.isDelivered"
                    :value="starter.isDelivered"
                    :disabled="starter.isDelivered || !showMarcharSegundos"
                    @change="
                      menuGroupStarterItemDeliveredChecked(order, starter)
                    "
                  ></v-checkbox>
                </span>
                <span class="quantity">
                  {{ order.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ starter.name }}</span>
                <span class="price">{{
                  formatPrice(starter.additional_charge * order.quantity)
                }}</span>
              </li>
              <li
                class="order-metadata-title"
                v-if="order.maincourse.length > 0"
              >
                PLATOS PRINCIPALES
              </li>
              <li
                class="recent-orders-item"
                v-for="main in order.maincourse"
                :key="`main_order_${main.id}`"
              >
                <span class="delivered">
                  <v-checkbox
                    class="mt-0"
                    v-model="main.isDeliveredMainCourse"
                    :value="main.isDeliveredMainCourse"
                    :disabled="main.isDeliveredMainCourse"
                    @change="
                      menuGroupMainCourseItemDeliveredChecked(order, main)
                    "
                  ></v-checkbox>
                </span>
                <span class="quantity">
                  {{ order.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ main.name }}</span>
                <div v-if="main.notes" class="notes">
                  <span>{{ main.notes }}</span>
                </div>
                <span class="price">{{
                  formatPrice(main.additional_charge * order.quantity)
                }}</span>
              </li>

              <li class="order-metadata-title" v-if="order.desserts.length > 0">
                POSTRES
              </li>
              <li
                class="recent-orders-item"
                v-for="dessert in order.desserts"
                :key="`dessert_order_${dessert.id}`"
              >
                <span class="quantity">
                  {{ order.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ dessert.name }}</span>
                <div v-if="dessert.notes" class="notes">
                  <span>{{ dessert.notes }}</span>
                </div>
                <span class="price">{{
                  formatPrice(dessert.additional_charge * order.quantity)
                }}</span>
              </li>

              <li class="order-metadata-title" v-if="order.drinks.length > 0">
                BEBIDA
              </li>
              <li
                class="recent-orders-item"
                v-for="drink in order.drinks"
                :key="`drink_order_${drink.id}`"
              >
                <span class="quantity">
                  {{ order.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ drink.name }}</span>
                <div v-if="drink.notes" class="notes">
                  <span>{{ drink.notes }}</span>
                </div>
                <span class="price">{{
                  formatPrice(drink.additional_charge * order.quantity)
                }}</span>
              </li>
            </ul>

            <ul
              class="recent-orders-items-list"
              v-if="order.selectOption === 'invitation'"
            >
              <div class="invitation-header">
                <h3 class="recent-orders-product-type">INVITACIÓN</h3>
              </div>
              <li class="recent-menugroup-orders-item">
                <h3
                  class="recent-orders-product-type"
                  style="grid-column: span 5/7"
                >
                  {{ order.name }}
                </h3>

                <span class="price">
                  -
                  {{
                    formatPrice(
                      order.price * order.quantity +
                        totalWithAdditionalCharge(order)
                    )
                  }}</span
                >
              </li>
            </ul>
          </div>
          <!-- Menu Group End -->
          <div v-if="getCartDrinks().length > 0">
            <h3 class="recent-orders-product-type">Bebidas</h3>
            <ul class="recent-orders-items-list">
              <li
                class="recent-orders-item"
                v-for="(drink, index) in getCartDrinks()"
                :key="`drink_${index}`"
              >
                <button
                  v-if="!hasRoleWaiter"
                  type="button"
                  class="remove-product"
                  @click="openSelectOptionModel(drink)"
                >
                  <font-awesome-icon
                    icon="minus-square"
                    :style="{ color: '#ea2222', fontSize: 20 }"
                  />
                </button>
                <span class="quantity">
                  {{ drink.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ drink.name }}</span>
                <span class="size">{{ sizeText(drink) }}</span>
                <div v-if="drink.notes" class="notes">
                  <span>{{ drink.notes }}</span>
                </div>
                <span class="price">{{
                  formatPrice(drink.price * drink.quantity)
                }}</span>
                <span class="paid-check" v-if="isPaid(drink)">
                  <font-awesome-icon
                    icon="check"
                    :style="{ color: '#634e42', fontSize: 20 }"
                  />
                </span>
              </li>
            </ul>
          </div>
          <template v-if="getCartDrinks().length > 0">
            <ul
              class="recent-orders-items-list"
              v-if="getCartDrinks().length > 0"
            >
              <li
                class="recent-orders-item"
                v-for="(drink, index) in getCartDrinks()"
                :key="`drink_${index}`"
                :style="{
                  display: drink.selectOption === 'invitation' ? 'grid' : 'none'
                }"
              >
                <template v-if="drink.selectOption === 'invitation'">
                  <div class="invitation-header">
                    <h3 class="recent-orders-product-type">INVITACIÓN</h3>
                  </div>
                  <span class="quantity">
                    {{ drink.removeQuantity }}
                    <em>x</em>
                  </span>
                  <span class="name">{{ drink.name }}</span>
                  <span class="price"
                    >-
                    {{ formatPrice(drink.price * drink.removeQuantity) }}</span
                  >
                </template>
              </li>
            </ul>
          </template>
          <div v-if="getCartDesserts().length > 0">
            <h3 class="recent-orders-product-type">Postre</h3>
            <ul class="recent-orders-items-list">
              <li
                class="recent-orders-item"
                v-for="(dessert, index) in getCartDesserts()"
                :key="`dessert_${index}`"
              >
                <button
                  v-if="!hasRoleWaiter"
                  type="button"
                  class="remove-product"
                  @click="openSelectOptionModel(dessert)"
                >
                  <font-awesome-icon
                    icon="minus-square"
                    :style="{ color: '#ea2222', fontSize: 20 }"
                  />
                </button>
                <span class="quantity">
                  {{ dessert.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ dessert.name }}</span>
                <span class="size">{{ sizeText(dessert) }}</span>
                <div v-if="dessert.notes" class="notes">
                  <span>{{ dessert.notes }}</span>
                </div>
                <span class="price">{{
                  formatPrice(dessert.price * dessert.quantity)
                }}</span>
                <span class="paid-check" v-if="isPaid(dessert)">
                  <font-awesome-icon
                    icon="check"
                    :style="{ color: '#634e42', fontSize: 20 }"
                  />
                </span>
              </li>
            </ul>
          </div>
          <template v-if="getCartDesserts().length > 0">
            <ul
              class="recent-orders-items-list"
              v-if="getCartDesserts().length > 0"
            >
              <li
                class="recent-orders-item"
                v-for="(dessert, index) in getCartDesserts()"
                :key="`dessert_${index}`"
                :style="{
                  display:
                    dessert.selectOption === 'invitation' ? 'grid' : 'none'
                }"
              >
                <template v-if="dessert.selectOption === 'invitation'">
                  <div class="invitation-header">
                    <h3 class="recent-orders-product-type">INVITACIÓN</h3>
                  </div>
                  <span class="quantity">
                    {{ dessert.removeQuantity }}
                    <em>x</em>
                  </span>
                  <span class="name">{{ dessert.name }}</span>
                  <span class="price"
                    >-
                    {{
                      formatPrice(dessert.price * dessert.removeQuantity)
                    }}</span
                  >
                </template>
              </li>
            </ul>
          </template>
          <div v-if="hasFoodTypeOrder()">
            <h3 class="recent-orders-product-type">Comida</h3>
            <ul class="recent-orders-items-list">
              <li
                class="recent-orders-item"
                v-for="food in getCartFood()"
                :key="`food_${food.id}`"
              >
                <button
                  v-if="!hasRoleWaiter"
                  type="button"
                  class="remove-product"
                  @click="openSelectOptionModel(food)"
                >
                  <font-awesome-icon
                    icon="minus-square"
                    :style="{ color: '#ea2222', fontSize: 20 }"
                  />
                </button>
                <span class="quantity">
                  {{ food.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ food.name }}</span>
                <div v-if="food.notes" class="notes">
                  <span>{{ food.notes }}</span>
                </div>
                <span class="price">{{
                  weight(food) + formatPrice(food.price * food.quantity)
                }}</span>
                <span class="paid-check" v-if="isPaid(food)">
                  <font-awesome-icon
                    icon="check"
                    :style="{ color: '#634e42', fontSize: 20 }"
                  />
                </span>
              </li>
              <li
                class="order-metadata-title"
                v-if="getCartFoodShared().length"
              >
                {{ shareLabel }}
              </li>
              <li
                class="recent-orders-item"
                v-for="food in getCartFoodShared()"
                :key="`food_${food.id}`"
              >
                <span class="delivered" v-if="shareLabel === 'PRIMEROS'">
                  <v-checkbox
                    class="mt-0"
                    v-model="food.isDelivered"
                    :value="food.isDelivered"
                    :disabled="food.isDelivered || !showMarcharSegundos"
                    @change="starterItemDeliveredChecked(food)"
                  ></v-checkbox>
                </span>
                <button
                  v-if="!hasRoleWaiter"
                  type="button"
                  class="remove-product"
                  @click="openSelectOptionModel(food)"
                >
                  <font-awesome-icon
                    icon="minus-square"
                    :style="{ color: '#ea2222', fontSize: 20 }"
                  />
                </button>
                <span class="quantity">
                  {{ food.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ food.name }}</span>
                <div v-if="food.notes" class="notes">
                  <span>{{ food.notes }}</span>
                </div>
                <span class="price">{{
                  formatPrice(food.price * food.quantity)
                }}</span>

                <span class="paid-check" v-if="isPaid(food)">
                  <font-awesome-icon
                    icon="check"
                    :style="{ color: '#634e42', fontSize: 20 }"
                  />
                </span>
              </li>
              <li
                class="order-metadata-title"
                v-if="getCartFoodMainCourse().length"
              >
                PLATOS PRINCIPALES
              </li>
              <li
                class="recent-orders-item"
                v-for="food in getCartFoodMainCourse()"
                :key="`food_${food.id}`"
              >
                <span class="delivered" v-if="shareLabel === 'PRIMEROS'">
                  <v-checkbox
                    class="mt-0"
                    v-model="food.isDeliveredMainCourse"
                    :value="food.isDeliveredMainCourse"
                    :disabled="food.isDeliveredMainCourse"
                    @change="mainCourseItemDeliveredChecked(food)"
                  ></v-checkbox>
                </span>

                <button
                  v-if="!hasRoleWaiter"
                  type="button"
                  class="remove-product"
                  @click="openSelectOptionModel(food)"
                >
                  <font-awesome-icon
                    icon="minus-square"
                    :style="{ color: '#ea2222', fontSize: 20 }"
                  />
                </button>
                <span class="quantity">
                  {{ food.quantity }}
                  <em>x</em>
                </span>
                <span class="name">{{ food.name }}</span>
                <div v-if="food.notes" class="notes">
                  <span>{{ food.notes }}</span>
                </div>
                <span class="price">{{
                  formatPrice(food.price * food.quantity)
                }}</span>

                <span class="paid-check" v-if="isPaid(food)">
                  <font-awesome-icon
                    icon="check"
                    :style="{ color: '#634e42', fontSize: 20 }"
                  />
                </span>
              </li>
            </ul>
          </div>
          <template v-if="hasFoodTypeOrder()">
            <ul class="recent-orders-items-list">
              <li
                class="recent-orders-item"
                v-for="food in getCartFood()"
                :key="`food__${food.id}`"
                :style="{
                  display: food.selectOption === 'invitation' ? 'grid' : 'none'
                }"
              >
                <template v-if="food.selectOption === 'invitation'">
                  <div class="invitation-header">
                    <h3 class="recent-orders-product-type">INVITACIÓN</h3>
                  </div>
                  <span class="quantity">
                    {{ food.removeQuantity }}
                    <em>x</em>
                  </span>
                  <span class="name">{{ food.name }}</span>
                  <span class="price">{{
                    formatPrice(food.price * food.removeQuantity)
                  }}</span>
                </template>
              </li>

              <li
                class="recent-orders-item"
                v-for="food in getCartFoodMainCourse()"
                :key="`food__${food.id}`"
                :style="{
                  display: food.selectOption === 'invitation' ? 'grid' : 'none'
                }"
              >
                <template v-if="food.selectOption === 'invitation'">
                  <div class="invitation-header">
                    <h3 class="recent-orders-product-type">INVITACIÓN</h3>
                  </div>
                  <span class="quantity">
                    {{ food.removeQuantity }} <em>x</em>
                  </span>
                  <span class="name">{{ food.name }}</span>
                  <span class="price">
                    - {{ formatPrice(food.price * food.removeQuantity) }}</span
                  >
                </template>
              </li>

              <li
                class="recent-orders-item"
                v-for="food in getCartFoodShared()"
                :key="`food__${food.id}`"
                :style="{
                  display: food.selectOption === 'invitation' ? 'grid' : 'none'
                }"
              >
                <template v-if="food.selectOption === 'invitation'">
                  <div class="invitation-header">
                    <h3 class="recent-orders-product-type">INVITACIÓN</h3>
                  </div>
                  <span class="quantity">
                    {{ food.removeQuantity }}
                    <em>x</em>
                  </span>
                  <span class="name">{{ food.name }}</span>
                  <span class="price">
                    - {{ formatPrice(food.price * food.removeQuantity) }}</span
                  >
                </template>
              </li>
            </ul>
          </template>
          <div class="total-price">
            <span class="label">Total:</span>
            <span class="total-price-value">{{
              formatPrice(getTotalPrice(orders) - getInvitationTotalPrice())
            }}</span>
          </div>
          <div
            class="expandable-row"
            v-if="comments[time] && comments[time].length > 0"
          >
            <div class="table-cell">
              <div class="general-notes">Comentarios:</div>
              <div class="general-desc">{{ comments[time][0].comment }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SelectOptionpDialog
      @removeProduct="removeProductFromOrder($event)"
      ref="selectOptionDialog"
    ></SelectOptionpDialog>
  </div>
</template>

<script>
import SelectOptionpDialog from "@/components/admin/order/SelectOptionpDialog";
import { firestoreTimestamp } from "@/firebaseConfig";
import { drinksCollection } from "@/collections/drinks";
import { foodCollection } from "@/collections/food";
import { printersCollection } from "@/collections/printers";
import { every } from "lodash";
import printerMixin from "@/mixins/printer/printerMixin";
import moment from "moment";
import { deleteOrder, updateOrder } from "@/collections/orders";
import {
  ordersTotalByTableCollection,
  updateOrderTotalByTable
} from "@/collections/ordersTotalByTable";
import { orderCommentsCollection } from "@/collections/orderComments";
import { productTypesCollection } from "@/collections/productTypes";
import { updateDrink } from "@/collections/drinks";
import { updateFood } from "@/collections/food";
import { updateDessert } from "@/collections/dessert";

let timer = {};
export default {
  name: "order-by-time",
  props: ["time", "orders", "table", "selectedPrinters", "remaining"],
  mixins: [printerMixin],
  data() {
    return {
      orderComments: [],
      ordersTotalByTable: [],
      productTypesCollection: [],
      drinksCollection: [],
      foodCollection: [],
      starterItemDelivered: [],
      mainCourseItemDelivered: [],
      printers: []
      //timer: {},
    };
  },
  components: {
    SelectOptionpDialog
  },
  firestore() {
    return {
      orderComments: orderCommentsCollection.where("tableQR", "==", this.table),
      ordersTotalByTable: ordersTotalByTableCollection,
      productTypesCollection: productTypesCollection,
      drinksCollection: drinksCollection.orderBy("name"),
      foodCollection: foodCollection.orderBy("name"),
      printers: printersCollection.where("active", "==", true)
    };
  },
  computed: {
    showMarcharSegundos() {
      const { food } = this.$store.state.productTypeIds;
      let filterOrder = this.orders.filter(
        x =>
          (x.product_type_id === food &&
            x.metadata &&
            !x.canBeShared &&
            x.canBeMainCourse) ||
          false
      );

      let menuGroupOrder = this.orders.filter(item => {
        if (item.isMenuGroupProduct) {
          return item;
        }
      });

      let findMainCourse = menuGroupOrder.some(item => {
        if (item.maincourse && item.maincourse.length > 0) {
          return item;
        }
      });
      return findMainCourse ? findMainCourse : filterOrder.length > 0;
    },
    hasRoleWaiter() {
      return this.$store.getters.hasRoleWaiter;
    },
    shareLabel() {
      return process.env.VUE_APP_SHOW_SHARE_LABEL === "true"
        ? "A COMPARTIR"
        : "PRIMEROS";
    },
    ordersGrouped() {
      return this.arrayGroupBy(this.orders, "tableQR");
    },
    getMenuGroupOrders() {
      return this.orders.filter(item => {
        if (item.isMenuGroupProduct) {
          return item;
        }
      });
    },
    menuGroupOrderGroupBy() {
      return this.arrayGroupBy(this.getMenuGroupOrders, "tableQR");
    }
  },
  watch: {
    ordersGrouped() {
      let orders = this.ordersGrouped[this.table];
      let foundPrinted = orders.some(item => {
        if (item.isPrinted) {
          return item;
        }
      });

      if (!foundPrinted) {
        let foundCheckedPlatoPrincipal = orders.some(item => {
          if (item.isDeliveredMainCourse) {
            return item;
          }
        });

        if (!foundCheckedPlatoPrincipal) {
          let foundPlatoPrincipal = orders.some(item => {
            if (item.canBeMainCourse) {
              return item;
            }
          });
          if (foundPlatoPrincipal) {
            let filterPrimeros = orders.filter(item => {
              if (item.canBeShared) {
                return item;
              }
            });
            let allChecked = every(filterPrimeros, ["isDelivered", true]);
            if (allChecked) {
              // eslint-disable-next-line
              console.log("all pimaros are checked");
              timer[this.table] = setTimeout(() => {
                // eslint-disable-next-line
                console.log("timer 1");
                orders.forEach(item => {
                  updateOrder(item.id, {
                    isDelivered: true,
                    isPrinted: true
                  }).catch(error => {
                    this.setlogError(
                      "update_order",
                      "Obtained error message in ordersGrouped watch",
                      error.stack,
                      this.$options.name
                    );
                  });
                });
                this.orderPrinting(this.table, orders);
              }, this.settings.timerSeconds.split(" ")[0] * 60000);
            }
          }
        }
      }
    },
    menuGroupOrderGroupBy() {
      let orders = this.menuGroupOrderGroupBy[this.table];
      if (orders && orders.length > 0) {
        let foundPrinted = [];
        orders.forEach(item => {
          item.starters.forEach(x => {
            if (x.isPrinted) {
              foundPrinted.push(x);
            }
          });
        });

        if (foundPrinted.length === 0) {
          let foundPlatoPrincipal = [];
          orders.forEach(item => {
            item.maincourse.forEach(x => {
              foundPlatoPrincipal.push(x);
            });
          });

          if (foundPlatoPrincipal.length > 0) {
            let allStarters = [];
            orders.forEach(item => {
              item.starters.forEach(x => {
                allStarters.push(x);
              });
            });

            let allChecked = every(allStarters, ["isDelivered", true]);
            if (allChecked) {
              // eslint-disable-next-line
              console.log("all menu pimaros are checked");
              timer[this.table] = setTimeout(() => {
                // eslint-disable-next-line
                console.log("time 2");
                orders.forEach(item => {
                  item.starters.map(starter => {
                    starter.isDelivered = true;
                    starter.isPrinted = true;
                    return starter;
                  });
                  updateOrder(item.id, { starters: item.starters }).catch(
                    error => {
                      this.setlogError(
                        "update_order",
                        "Obtained error message in menuGroupOrderGroupBy watch",
                        error.stack,
                        this.$options.name
                      );
                    }
                  );

                  item.maincourse.map(main => {
                    main.isDelivered = true;
                    main.isPrinted = true;
                    return main;
                  });
                  updateOrder(item.id, { maincourse: item.maincourse }).catch(
                    error => {
                      this.setlogError(
                        "update_order",
                        "Obtained error message in menuGroupOrderGroupBy watch",
                        error.stack,
                        this.$options.name
                      );
                    }
                  );

                  item.desserts.map(dessert => {
                    dessert.isDelivered = true;
                    dessert.isPrinted = true;
                    return dessert;
                  });
                  updateOrder(item.id, { desserts: item.desserts }).catch(
                    error => {
                      this.setlogError(
                        "update_order",
                        "Obtained error message in menuGroupOrderGroupBy watch",
                        error.stack,
                        this.$options.name
                      );
                    }
                  );

                  item.drinks.map(drink => {
                    drink.isDelivered = true;
                    drink.isPrinted = true;
                    return drink;
                  });
                  updateOrder(item.id, { drinks: item.drinks }).catch(error => {
                    this.setlogError(
                      "update_order",
                      "Obtained error message in menuGroupOrderGroupBy watch",
                      error.stack,
                      this.$options.name
                    );
                  });
                });

                this.orderPrinting(this.table, orders);
              }, this.settings.timerSeconds.split(" ")[0] * 60000);
            }
          }
        }
      }
    }
  },
  methods: {
    weight(order) {
      return order.weight ? order.weight + "Kg \xa0\xa0\xa0\xa0\xa0" : " ";
    },
    orderPrinting(table, orders) {
      // orders.forEach((item) => {
      if (
        !this.selectedPrinters ||
        (this.selectedPrinters && !this.selectedPrinters.length)
      ) {
        this.showErrorMessage("No hay ninguna impresora seleccionada!");
        return;
      }

      this.makePrinterCall(orders, table, this.printers, "open-orders");
      this.showSuccessMessage("Se ha enviado a cocina MARCHAR SEGUNDOS!");
    },
    getDate(order) {
      return order.length > 0 ? order[0].time : undefined;
    },
    comments() {
      return this.arrayGroupBy(this.orderComments, "time");
    },
    getCartDrinks() {
      const { drinks } = this.$store.state.productTypeIds;
      return this.orders.filter(
        item => item.product_type_id === drinks && item.metadata
      );
    },
    getCartDesserts() {
      const { dessert } = this.$store.state.productTypeIds;
      return this.orders.filter(
        item => item.product_type_id === dessert && item.metadata
      );
    },
    getCartFoodShared() {
      const { food } = this.$store.state.productTypeIds;
      return this.orders.filter(
        x =>
          x.product_type_id === food && x.metadata && (x.canBeShared || false)
      );
    },
    getCartFoodMainCourse() {
      const { food } = this.$store.state.productTypeIds;
      return this.orders.filter(
        x =>
          (x.product_type_id === food &&
            x.metadata &&
            !x.canBeShared &&
            x.canBeMainCourse) ||
          false
      );
    },
    hasFoodTypeOrder() {
      const { food } = this.$store.state.productTypeIds;
      return this.orders.find(x => x.product_type_id === food);
    },
    getCartFood() {
      const { food } = this.$store.state.productTypeIds;
      return this.orders.filter(
        x =>
          x.product_type_id === food &&
          x.metadata &&
          !x.canBeShared &&
          !x.canBeMainCourse
      );
    },
    getInvitationTotalPrice() {
      let total = 0;
      this.orders.forEach(item => {
        if (item.selectOption === "invitation") {
          total +=
            item.removeQuantity * item.price +
            this.totalWithAdditionalCharge(item);
        }
      });
      return total;
    },
    isPaid(order) {
      let isPaid = true;
      // eslint-disable-next-line no-unused-vars
      for (const [quantity, metadata] of Object.entries(order.metadata)) {
        if (!metadata.isPaid) {
          isPaid = false;
        }
      }
      return isPaid;
    },
    openSelectOptionModel(item) {
      if (
        this.remaining > 0 &&
        item &&
        item.metadata &&
        item.metadata[0].isPaid === false
      ) {
        this.$refs.selectOptionDialog.open(item);
        return;
      }
      this.showErrorMessage("algo salió mal");
    },
    removeProductFromOrder(data) {
      let item = data.item;
      item.selectOption = data.selectOption;

      const selectOption = data.selectOption;

      switch (selectOption) {
        case "invitation":
          this.invitation(item);
          break;
        case "userError":
          this.userError(item);
          break;
        case "outOfStock":
          this.outOfStock(item);
          break;
        default:
          // eslint-disable-next-line
          console.log("SIN PAGAR.");
      }
    },
    async invitation(item) {
      try {
        let time = firestoreTimestamp.fromDate(new Date());
        if (item.removeQuantity === item.quantity) {
          this.showErrorMessage("algo salió mal. no puedes invitar");
          return;
        }
        item.removeQuantity = item.removeQuantity + 1;

        let orderByTotal = this.ordersTotalByTable.find(
          x => x.id === item.tableQR
        );
        let remaining = 0;
        remaining =
          parseFloat(orderByTotal.remaining).toFixed(2) -
          parseFloat(item.price + this.totalWithAdditionalCharge(item)).toFixed(
            2
          );

        if (remaining <= 0) {
          remaining = 0;
        }

        this.$emit("setRemaing", remaining);

        await updateOrderTotalByTable(item.tableQR, {
          remaining: parseFloat(remaining.toFixed(2)),
          time: time
        });

        if (item && item.quantity < 0) {
          this.removeOrder(item.id);
        } else {
          await updateOrder(item.id, item);
        }

        this.$emit("deleteOrder", item);
      } catch (error) {
        this.setlogError(
          "update_order/update_order_total_by_table",
          "Obtained error message in invitation()",
          error.stack,
          this.$options.name
        );
      }
    },
    async userError(item) {
      try {
        let time = firestoreTimestamp.fromDate(new Date());
        item.removeQuantity = item.quantity;

        if (
          !this.selectedPrinters ||
          (this.selectedPrinters && !this.selectedPrinters.length)
        ) {
          this.showErrorMessage("No hay ninguna impresora seleccionada!");
          return;
        }

        if (!this.printersAreActive) {
          this.showErrorMessage("Las impresoras no estan activas");
          return;
        }

        const data = {
          id: item.tableQR,
          table: {
            to_share: [],
            seconds: [],
            all: []
          },
          general_comment: `El producto ${item.name} se ha eliminado de la cuenta en la mesa ${item.tableQR}`,
          time: this.formatDateTime(item.time)
        };

        // Make API call to send to selectedPrinters
        this.selectedPrinters.forEach(printerUrl => {
          let printerName = "";
          if (this.printers && this.printers.length) {
            let printer = this.printers.find(p => p.url === printerUrl);
            printerName = printer ? printer.name : "";
          }
          this.postPrinterRequest(printerUrl, data, printerName, "open-orders");
        });

        this.showSuccessMessage("Se ha enviado a cocina MARCHAR SEGUNDOS!");

        let orderByTotal = this.ordersTotalByTable.find(
          x => x.id === item.tableQR
        );
        let remaining = 0;
        remaining =
          parseFloat(orderByTotal.remaining).toFixed(2) -
          parseFloat(
            item.quantity * item.price + this.totalWithAdditionalCharge(item)
          ).toFixed(2);

        if (remaining <= 0) {
          remaining = 0;
        }

        this.$emit("setRemaing", remaining);

        await updateOrderTotalByTable(item.tableQR, {
          remaining: parseFloat(remaining.toFixed(2)),
          time: time
        });

        this.removeOrder(item.id);

        this.$emit("deleteOrder", item);
      } catch (error) {
        this.setlogError(
          "update_order_total_by_table",
          "Obtained error message in userError()",
          error.stack,
          this.$options.name
        );
      }
    },
    async outOfStock(item) {
      try {
        let time = firestoreTimestamp.fromDate(new Date());
        item.removeQuantity = item.quantity;

        // this.setStockZero(item);

        let orderByTotal = this.ordersTotalByTable.find(
          x => x.id === item.tableQR
        );
        let remaining = 0;
        remaining =
          parseFloat(orderByTotal.remaining).toFixed(2) -
          parseFloat(
            item.quantity * item.price + this.totalWithAdditionalCharge(item)
          ).toFixed(2);

        if (remaining <= 0) {
          remaining = 0;
        }
        this.removeOrder(item.id);
        this.$emit("setRemaing", remaining);

        await updateOrderTotalByTable(item.tableQR, {
          remaining: parseFloat(remaining.toFixed(2)),
          time: time
        });

        this.$emit("deleteOrder", item);
      } catch (error) {
        this.setlogError(
          "update_order_total_by_table",
          "Obtained error message in outOfStock()",
          error.stack,
          this.$options.name
        );
      }
    },
    async setStockZero(item) {
      try {
        let data = {
          stock: 0,
          updated_on: moment().format()
        };

        if (
          item.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID
        ) {
          await updateDrink(item.product_id, data);
          return;
        }

        if (item.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID) {
          await updateFood(item.product_id, data);
          return;
        }

        if (
          item.product_type_id === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
        ) {
          await updateDessert(item.product_id, data);
        }
      } catch (error) {
        this.setlogError(
          "update_drink/food/desser",
          "Obtained error message in setStockZero()",
          error.stack,
          this.$options.name
        );
      }
    },
    async removeOrder(id) {
      try {
        await deleteOrder(id);
      } catch (error) {
        this.setlogError(
          "delete_order",
          "Obtained error message in removeOrder()",
          error.stack,
          this.$options.name
        );
      }
    },
    async menuGroupStarterItemDeliveredChecked(item, groupItem) {
      try {
        if (item.isMenuGroupProduct) {
          this.storeTimeStamp(item);
          item.starters.map(starter => {
            if (starter.id === groupItem.id) {
              starter.isDelivered = groupItem.isDelivered;
            }
            return starter;
          });

          await updateOrder(item.id, { starters: item.starters });
          let data = {
            item: item,
            groupItem: groupItem
          };
          this.$emit("isDeliveredCheckedMenuGroup", data);
        }
      } catch (error) {
        this.setlogError(
          "update_order",
          "Obtained error message in menuGroupStarterItemDeliveredChecked()",
          error.stack,
          this.$options.name
        );
      }
    },
    async starterItemDeliveredChecked(item) {
      try {
        let isDelivered = false;

        if (item.isDelivered) {
          this.storeTimeStamp(item);
          isDelivered = item.isDelivered;
        }
        await updateOrder(item.id, { isDelivered: isDelivered });
        item.isDelivered = item.isDelivered !== null;
        this.$emit("isDeliveredChecked", item);
      } catch (error) {
        this.setlogError(
          "update_order",
          "Obtained error message in starterItemDeliveredChecked()",
          error.stack,
          this.$options.name
        );
      }
    },
    async menuGroupMainCourseItemDeliveredChecked(item, groupItem) {
      try {
        if (item.isMenuGroupProduct) {
          this.storeTimeStamp(this.orders[0]);
          item.maincourse.map(main => {
            if (main.id === groupItem.id) {
              main.isDeliveredMainCourse = groupItem.isDeliveredMainCourse;
            }
            return main;
          });
        }
        await updateOrder(item.id, { maincourse: item.maincourse });
        let data = {
          item: item,
          groupItem: groupItem
        };
        this.$emit("isMainCourseDeliveredCheckedMenuGroup", data);
      } catch (error) {
        this.setlogError(
          "update_order",
          "Obtained error message in menuGroupMainCourseItemDeliveredChecked()",
          error.stack,
          this.$options.name
        );
      }
    },
    async mainCourseItemDeliveredChecked(item) {
      try {
        let isDeliveredMainCourse = false;
        if (item.isDeliveredMainCourse) {
          this.storeTimeStamp(item);
          isDeliveredMainCourse = item.isDeliveredMainCourse;
        }
        await updateOrder(item.id, {
          isDeliveredMainCourse: isDeliveredMainCourse
        });
        this.$emit("isMainCourseDeliveredChecked", item);
      } catch (error) {
        this.setlogError(
          "update_order",
          "Obtained error message in mainCourseItemDeliveredChecked()",
          error.stack,
          this.$options.name
        );
      }
    },
    async storeTimeStamp(item) {
      try {
        await updateOrder(item.id, {
          checkedTimestamp: firestoreTimestamp.fromDate(new Date())
        });
      } catch (error) {
        this.setlogError(
          "update_order",
          "Obtained error message in storeTimeStamp()",
          error.stack,
          this.$options.name
        );
      }
    },
    stopTimer(table) {
      // eslint-disable-next-line
      console.log(table);
      // eslint-disable-next-line
      console.log(timer, "timer");

      for (let k in timer) {
        if (k === table) {
          // eslint-disable-next-line
          console.log(k, "KKKKKKKKKK");
          clearTimeout(timer[k]);
        }
      }
    }
  }
};
</script>

<style></style>
